const TYPES = {
  DEFAULT: 'default',
  INVERSE: 'inverse',
  LINK: 'link',
  GRAY: 'gray',
  DARK_GRAY: 'dark-gray',
  OUTLINE: 'outline',
};

export { TYPES };

export default TYPES;
